import type { Broadcast } from '../types';

export function audienceSummary(broadcast: Broadcast): string {
  const count = countLabel(broadcast);
  const parts = criteriaParts(broadcast);
  if (count && parts.length > 0) return `${count} · ${parts.join(' · ')}`;
  if (count) return count;
  return parts.length > 0 ? `Workers · ${parts.join(' · ')}` : 'Workers';
}

function countLabel(b: Broadcast): string | null {
  const f = b.audience_filter;
  const n =
    b.recipient_count ??
    (f?.mode === 'direct' ? (f.user_ids?.length ?? null) : null);
  if (n == null) return null;
  return n === 1 ? '1 worker' : `${n} workers`;
}

function criteriaParts(b: Broadcast): string[] {
  const f = b.audience_filter;
  if (!f) return [];
  if (f.mode === 'direct') return ['Selected workers'];
  if (f.mode === 'legacy_import') return ['Legacy announcement'];
  const parts: string[] = [];
  const skillsCount = f.skills?.length ?? 0;
  if (skillsCount > 0)
    parts.push(`${skillsCount} skill${skillsCount === 1 ? '' : 's'}`);
  if (f.tax_types?.length) parts.push(f.tax_types.join('+').toUpperCase());
  if (f.location)
    parts.push(`${f.location.radius_miles}mi · ${f.location.zip_code}`);
  return parts;
}
